import React, { useState } from 'react';
import TextInput from '../../../Shared/TextInput/TextInput';
import Footer from '../Assets/footer';
import ErrorIcon from '../Assets/SVG/errorIcon';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import Config from '../../../../Config';
import { isMobile } from 'react-device-detect';
import WhatsappIcon from '../Assets/SVG/whatsappIcon';

const ErrorScreen = (props) => {
    const mobileCall = (
        <BtnSubmit
            className='btn-submit-white TipCallBtn'
            isDisplayWhatsAppIcon={false}
            onclick={() => {
                window.location.href = 'tel:*'+ window.Config.technicalSupportPhone;
            }}
            text='תחזרו אליי'
        />
    );
    const desktopCall = <div className='TipCall'>לשיחה עם נציג {window.Config.technicalSupportPhone}</div>;
    return (
        <div className='screenContainer'>
            <ErrorIcon />
            <h3 className='heading withSecondary'>
                רק רגע... אנחנו לא מזהים
                <br /> את המספר
            </h3>

            {desktopCall}

            {props.isFull && (
                <Footer
                    text={'לעמוד הבית'}
                    onclick={() => {
                        window.location.href = Config.staticWebSiteUrl;
                    }}
                />
            )}
        </div>
    );
};

export default ErrorScreen;